/* Keep the product title as the page H1 when review apps render asynchronously. */
(() => {
  const selector = '#az_reviews h1.AreviewsHeader7-section-title, h1#rvHeading';

  function normalizeHeadings(root) {
    const headings = [...root.querySelectorAll(selector)];
    if (root.matches?.(selector)) headings.unshift(root);

    headings.forEach((heading) => {
      const replacement = document.createElement('h2');
      for (const attribute of heading.attributes) {
        replacement.setAttribute(attribute.name, attribute.value);
      }
      while (heading.firstChild) replacement.appendChild(heading.firstChild);
      heading.replaceWith(replacement);
    });
  }

  normalizeHeadings(document);
  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType === Node.ELEMENT_NODE && node.isConnected) {
          normalizeHeadings(node);
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
